import _ from 'lodash';
import allModelData from '@/admin_models/all';

export const modelData = _.merge({}, allModelData, {
})

export const getLabel = ({ item, v }) => {
  const label = modelData[v.extra.model_name]['label']
  if (typeof label === 'function') {
    return modelData[v.extra.model_name]['label'](item)
  } else {
    return item[modelData[v.extra.model_name]['label']]
  }
}
